import { StyledLibraryTopbar } from './LibraryTopbar.styled';
import { Title } from '@/shared/Typography';
import useLibraryUtils from '../useLibraryUtils.hook';
import { Avatar } from 'antd';
import { CaretRightFilled } from '@ant-design/icons';
import Link from 'next/link';

export default function LibraryTopbar({
  currentTheme = '',
  backButton = null,
}) {
  const { mode, isLibrary } = useLibraryUtils();

  return (
    mode == 'default' && (
      <StyledLibraryTopbar>
        {currentTheme ? (
          <>
            <Link href={isLibrary ? '/library' : '/themes'}>
              <a>
                <Title>
                  {isLibrary ? 'Library' : 'Themes'}
                  <CaretRightFilled />
                </Title>
              </a>
            </Link>
            <div className="theme-info">
              <Avatar
                size={40}
                src={currentTheme.thumb}
                shape="square"
                className="avatar"
              />
              <Title className="theme-title">{currentTheme.name}</Title>
            </div>
          </>
        ) : (
          <Title>Library</Title>
        )}
        <div className="back-button">{backButton}</div>
      </StyledLibraryTopbar>
    )
  );
}
